"use strict";

var scrollToHash = function scrollToHash(offsetY) {
  // Make sure React has had a change to flush to DOM first.
  setTimeout(function () {
    var hash = window.location.hash.replace(`#`, ``);
    if (hash !== ``) {
      var element = document.getElementById(hash);
      if (element) {
        var offset = element.offsetTop;
        window.scrollTo(0, offset - offsetY);
      }
    }
  }, 10);
};

exports.clientEntry = function (args, pluginOptions) {
  var offsetY = 0;
  if (pluginOptions.offsetY) {
    offsetY = pluginOptions.offsetY;
  }
  // This code is only so scrolling to header hashes works in development.
  // For production, the equivalent code is in gatsby-ssr.js.
  if (process.env.NODE_ENV !== `production`) {
    scrollToHash(offsetY);
  }
};

exports.onRouteUpdate = function (args, pluginOptions) {
  var offsetY = 0;
  if (pluginOptions.offsetY) {
    offsetY = pluginOptions.offsetY;
  }

  scrollToHash(offsetY);
};


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-typegen-remark-autolink-headers/gatsby-browser.js
// module id = ./node_modules/gatsby-typegen-remark-autolink-headers/gatsby-browser.js
// module chunks = 11